import {createLatestRequests} from './latest-requests'

type Owner={user?:string,token?:string}
const key=(owner:Owner)=>JSON.stringify([owner.user,owner.token])

// Retain the implicit trigger's public methods while replacing account data.
export function replaceImplicitData(store:any,value:any) {
    for(const name of Object.keys(store.get()||{})) {
        const property=Object.getOwnPropertyDescriptor(store,name)
        if(!Object.hasOwn(value,name) && property && 'value' in property && typeof property.value!=='function'
            && !['_','fields'].includes(name))delete store[name]
    }
    store.set(value)
}

export function createProfileSession({readOwner,load,save,publish,reset,optimistic,onError=()=>{}}:{
    readOwner:()=>Owner,load:(owner:Owner)=>Promise<any>,save:(owner:Owner,body:any)=>Promise<any>,
    publish:(profile:any)=>void,reset:(owner:Owner)=>void,optimistic:(patch:any,removed:string[])=>void,onError?:(error:any)=>void,
}) {
    const requests=createLatestRequests(()=>key(readOwner()))
    let active:Owner
    const accept=(request:any,owner:Owner,profile:any)=>{
        if(!request.current() || !profile || profile.user!==owner.user)return false
        publish(profile)
        return true
    }
    return {
        activate(owner:Owner) {
            if(active && key(active)===key(owner))return
            const changedUser=!active || active.user!==owner.user
            active={...owner};requests.enter('profile')
            if(changedUser)reset(owner)
            if(owner.user)return this.refresh()
        },
        refresh(profile:any=undefined) {
            const owner={...readOwner()}
            if(!owner.user || active && key(active)!==key(owner))return Promise.resolve(false)
            if(profile && profile.user!==owner.user)return Promise.resolve(false)
            const request=requests.begin('data','profile')
            if(profile) {
                try{return Promise.resolve(accept(request,owner,profile))}finally{request.finish()}
            }
            return requests.afterWrites('settings',request.owner,()=>request.current()?load(owner):undefined)
                .then(value=>accept(request,owner,value?.profile))
                .catch(error=>{if(request.current())onError(error);return false})
                .finally(()=>request.finish())
        },
        updateSettings(changes:any) {
            const owner={...readOwner()},patch=Object.fromEntries(Object.entries(changes).filter(([,value])=>value!==undefined))
            const removed=Object.keys(changes).filter(name=>changes[name]===undefined)
            optimistic(patch,removed)
            if(!owner.user)return Promise.resolve(false)
            const request=requests.begin('data','profile')
            const body=JSON.parse(JSON.stringify({settings:patch,settings_remove:removed,settings_patch:true}))
            return requests.enqueue('settings',request.owner,()=>save(owner,body))
                .then(value=>accept(request,owner,value?.profile))
                .catch(error=>{if(request.current())onError(error);return false})
                .finally(()=>request.finish())
        },
    }
}
